import React from 'react';


export default class Mudancatreino extends React.Component{
  constructor(props) {
    super(props);

    this.state = {

    };

  }

  getdataMasc(){
    return(
      <div>
        <strong>Como funciona a mudança dos treinos?</strong><br /><br />
        1 - Por que o Foco90 usa mudanças semanais?<br /><br />
        Algumas adaptações ocorrem muito rapidamente no organismo. Se pudermos mudar algo, sempre o estímulo e as mudanças podem também ser melhores.<br /><br />
        2 - Por que mesmo mudando sempre, SEMPRE temos algumas formas de agachamento, leg, supino, flexão, ponte, puxada e remada?<br /><br />
        Os exercícios com Maior ativação muscular e Maior exigência energética SÃO mais importantes e eficientes tanto no quesito estético quanto no quesito saúde. Eles sempre estarão presentes em suas variações.<br /><br />
        3 - Como posso ter certeza que o foco90 serve pra mim mesmo sem ter uma avaliação e saber o que quero?<br /><br />
        A metodologia foi criada baseada na ciência dos melhores resultados e em 20 anos de experiência do Roberto Jacob. Você tem 8 opções semanais e elas sempre cobrem o melhor e maior estímulo possível de emagrecimento, definição e Hipertrofia.<br /><br />
        4 - O Foco90 me prometeu treino novo toda semana e agora repete sempre o MESMO treino por 2 semanas variando a cadência e repetições. Por quê?<br /><br />
        A elaboração do treino segue muitos princípios difíceis de explicar, mas vou simplificar o básico abaixo:<br /><br />
        A - mudamos a estrutura de exercícios a cada 2 semanas para dar tempo de você aperfeiçoar a execução, melhorando sua consciência corporal e técnica do movimento específico.<br /><br />
        B - Mesmo mantendo os exercícios por 2 semanas, você vai ter que modificar cadência e/ou repetições e/ou séries e carga.<br /><br />
        C - Se mudarmos apenas UMA variável, já temos um treino novo.<br /><br />
        LEMBRE-SE SEMPRE DA SUA REALIDADE ANTERIOR, de talvez ter um único e velho treino por meses, e fazer muitas coisas ineficiente sem referência ou parâmetro científico. Aqui a gente trabalha para você! ;)<br />
      </div>
    );
  }

  getdataFem(){
    return(
      <div>
        <strong>Como funciona a mudança dos treinos?</strong><br /><br />
        1 - Por que o Foco90 usa mudanças semanais?<br /><br />
        Algumas adaptações ocorrem muito rapidamente no organismo. Se pudermos mudar algo, sempre o estímulo e as mudanças podem também ser melhores.<br /><br />
        2 - Por que mesmo mudando sempre, SEMPRE temos algumas formas de agachamento, leg, supino, flexão, ponte, puxada e remada?<br /><br />
        Os exercícios com Maior ativação muscular e Maior exigência energética SÃO mais importantes e eficientes tanto no quesito estético quanto no quesito saúde. Eles sempre estarão presentes em suas variações.<br /><br />
        3 - Como posso ter certeza que o foco90 serve pra mim mesmo sem ter uma avaliação e saber o que quero?<br /><br />
        A metodologia foi criada baseada na ciência dos melhores resultados e em 20 anos de experiência do Roberto Jacob. Você tem 10 opções semanais e elas sempre cobrem o melhor e maior estímulo possível de emagrecimento, definição e Hipertrofia.<br /><br />
        4 - O Foco90 me prometeu treino novo toda semana, o que isso significa?<br /><br />
        A elaboração do treino segue muitos princípios difíceis de explicar, mas vou simplificar o básico abaixo:<br /><br />
        A – a mudança nos exercícios ocorre de 1 a 2 semanas para dar tempo de você aperfeiçoar a execução, melhorando sua consciência corporal e técnica do movimento específico.<br /><br />
        B - Mesmo mantendo os exercícios por 2 semanas, você vai ter que modificar cadência e/ou repetições e/ou séries e carga.<br /><br />
        C - Se mudarmos apenas UMA variável, já temos um treino novo.<br /><br />
        LEMBRE-SE SEMPRE DA SUA REALIDADE ANTERIOR, de talvez ter um único e velho treino por meses, e fazer muitas coisas ineficiente sem referência ou parâmetro científico. Aqui a gente trabalha para você! ;)<br />
      </div>
    );
  }

  render(){
    const strings = this.state.strings;

    const wrapper = this.props.sexo === 'F' || this.props.sexo === 'f' ? this.getdataFem() : this.getdataMasc();

    return(
      wrapper
    );
  }
}



// WEBPACK FOOTER //
// ./src/classes/tecnicas/Mudancatreino.js